export function isModuleSupported() {
    try {
        new Function('import("")');
        return true;
    } catch (_) {
        return false;
    }
};
